<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 companies-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div class="breadcrumbs-section padding-left">
        <span class="prev-page pt-1 "><a routerLink="/overview">Home</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="prev-page pt-1 "><a routerLink="/faq">FAQs</a></span>
        <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
        <span class="curr-page  breadcrumbs-section-font">{{pageText}} FAQ</span>
      </div>


      <div class="add-faq-layout ">
        <div class="row mb-5">
          <div class="col-10">
            <h1>{{pageText}} FAQ</h1>
          </div>
          <div class="col-2">
            <button (click)="save('save')">{{pageText}}</button>
          </div>
        </div>
        <div style="color: red;">{{errorText}}</div>
        <div class="mb-5" *ngFor="let faq of faqs; let i = index;">
          <div class="row mt-3">
            <div class="col-12">
              <p>Question</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <textarea type="text" (change)="check($event)" [(ngModel)]="faq.question"
                [ngClass]="{'error-input' : error[faq.question+i]}" name="question_{{i}}" rows="1"></textarea>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <p>Description</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <textarea class="input-des" (change)="check($event)" type="text" [(ngModel)]="faq.answer"
                [ngClass]="{'error-input' : error[faq.answer+i]}" name="answer{{i}}" rows="1"></textarea>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!id">
          <div class="col-12">
            <button class="button-add" type="submit" (click)="addFaq()">+ Add another Question</button>
          </div>
        </div>
      </div>

      <ng-template #content let-modal class="text-center">
        <div class="modal-height">
          <div class="modal-body">
            <div class="">
              <div class="text pt-3 pb-3">Are you sure you want to quit?</div>
              <div class="popup-line"></div>
            </div>
          </div>
          <div class="submit col-12 d-flex justify-content-end ">
            <div class="pr-3">
              <button type="button " class="cancel-button pt-3" (click)="modal.close('Save click')"><span
                  class="cancel">Cancel</span></button>
            </div>
            <button type="button " class="add-button"><span class="add"
                (click)="modal.close('Save click');displayPopup();">Quit</span></button>
          </div>
        </div>
      </ng-template>

    </div>
  </div>

</div>
